import { render, staticRenderFns } from "./BulkProfileUpdate.vue?vue&type=template&id=4617d415&scoped=true&"
import script from "./BulkProfileUpdate.vue?vue&type=script&lang=ts&"
export * from "./BulkProfileUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProfileUpdate.vue?vue&type=style&index=0&id=4617d415&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4617d415",
  null
  
)

export default component.exports